import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.basic', {
        url: '/basic',
        component: 'userProfileBasic'
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/basic.state.js